import { createContext, useContext, useEffect, useRef, useState, useCallback, useMemo } from "react";
import { WS_URL } from "@/lib/api";

const RTCtx = createContext(null);
export const useRealtime = () => useContext(RTCtx);

export function RealtimeProvider({ children }) {
  const listeners = useRef(new Set());
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    let ws, alive = true, retry;
    const connect = () => {
      try {
        ws = new WebSocket(WS_URL);
        ws.onopen = () => setConnected(true);
        ws.onclose = () => { setConnected(false); if (alive) retry = setTimeout(connect, 3000); };
        ws.onerror = () => { try { ws.close(); } catch (e) { console.warn("ws close on error failed", e); } };
        ws.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);
            listeners.current.forEach((fn) => fn(msg));
          } catch (err) { console.warn("ws message parse failed", err); }
        };
      } catch { retry = setTimeout(connect, 3000); }
    };
    connect();
    return () => { alive = false; clearTimeout(retry); try { ws && ws.close(); } catch (e) { console.warn("ws cleanup failed", e); } };
  }, []);

  const subscribe = useCallback((fn) => { listeners.current.add(fn); return () => listeners.current.delete(fn); }, []);
  const value = useMemo(() => ({ subscribe, connected }), [subscribe, connected]);
  return <RTCtx.Provider value={value}>{children}</RTCtx.Provider>;
}
